import {memo} from 'react';
import {Typography} from 'components/Typography';
import {BRAND_ALPHABET} from 'modules/brands/constants';
import {TBrandAlphabetLetter} from 'modules/brands/types';
import classNames from 'classnames';
import style from './style.module.scss';
import Link from 'components/CustomRoutingLink';

export type TBrandAlphabetProps = {
    className?: string;
    currentCode?: TBrandAlphabetLetter['filteredCode'];
    onChange: (selectedLetter: TBrandAlphabetLetter) => void;
};

export const BrandAlphabet = memo<TBrandAlphabetProps>(function BrandAlphabet({currentCode, onChange, className}) {
    const handleClick = (selectedLetter: TBrandAlphabetLetter) => {
        onChange(selectedLetter);
        return window.scrollTo({behavior: 'smooth', top: 0});
    };

    return (
        <ul className={classNames(style.brandAlphabet, className)}>
            {BRAND_ALPHABET.map((item) => (
                <li key={item.filteredCode}>
                    <Link href={`#${item.href}`} legacyBehavior={true} passHref={true}>
                        <a
                            className={style.link}
                            data-id={item.href}
                            data-name={'tab_1'}
                            onClick={(e) => {
                                e.preventDefault();
                                handleClick(item);
                            }}
                        >
                            <Typography
                                className={classNames(style.text, {[style.active]: currentCode === item.filteredCode})}
                                variant={'badge-m'}
                            >
                                {item.label}
                            </Typography>
                        </a>
                    </Link>
                </li>
            ))}
        </ul>
    );
});
